import React, { useContext, useMemo } from 'react'
import { useField } from 'formik'

import {
  styled,
  isWeb,
  getConfig,
  getFontSize,
  isVariable,
  Token,
} from 'tamagui'

import ReactCurrencyInput, {
  CurrencyInputProps,
} from 'react-currency-input-field'

import { FormFieldContext } from './shared'

import './FormCurrencyInput.web.css'

const CurrencyInput = styled(ReactCurrencyInput, {
  name: 'FormCurrencyInput',
  // @ts-expect-error tag is valid for web styled components
  tag: 'input',

  borderColor: '$borderColor',
  outlineWidth: 0,

  fontWeight: '400',
  outlineStyle: 'none',
  borderRadius: '$2',
  borderWidth: 1,
  color: '$color',
  backgroundColor: '$background',

  padding: '$2',

  ...(isWeb
    ? {
        tabIndex: 0,
      }
    : {
        focusable: true,
      }),

  // Tamagui isn't applying this for some reason...
  // Setting manually via CSS for now...
  // fontFamily: '$body',

  hoverStyle: {
    borderColor: '$borderColorHover',
  },

  focusStyle: { borderColor: '$borderColorFocus' },

  variants: {
    size: {
      '...size': (size) => {
        return {
          fontSize: size,
          lineHeight: size,
        }
      },
    },
  },

  defaultVariants: {
    size: '$5',
  },
} as const)

export const FormCurrencyInput = CurrencyInput.styleable(
  // @ts-ignore styleable typing issues with CurrencyInput component props
  (props: CurrencyInputProps & { size: Token }, ref: any) => {
    const formFieldContext = useContext(FormFieldContext)
    const [field, _meta, helpers] = useField(formFieldContext.name)

    // A bit of a Tamagui hack as the size prop doesn't work otherwise...
    const style = useMemo(() => {
      const config = getConfig()
      const size = props.size || '$5'

      const lineHeightToken = config.fontsParsed.$body?.lineHeight?.[size]

      return {
        lineHeight: lineHeightToken
          ? `${isVariable(lineHeightToken) ? lineHeightToken.val : +lineHeightToken}px`
          : undefined,
        fontSize: getFontSize(size),
      }
    }, [props.size])

    return (
      // @ts-ignore CurrencyInput type issues
      <CurrencyInput
        ref={ref}
        step={1}
        intlConfig={{ locale: 'en-US', currency: 'USD' }}
        allowDecimals={false}
        allowNegativeValue={false}
        defaultValue={field.value}
        style={style}
        {...props}
        onValueChange={(value, name, values) => {
          helpers.setValue(value)

          if (props.onValueChange) {
            props.onValueChange(value, name, values)
          }
        }}
      />
    )
  }
)
